import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import CitySelector from './CitySelector';




ReactDOM.render(<CitySelector />, document.getElementById('root'));


